import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },        
        themes: {
            light: {
                primary: '#1d71b8',
                secondary: '#D20050',
                tertiary: '#6F7072',
                background: '#000000',
            },
        },
    },
});
